module.exports = __webpack_public_path__ + "img/kukimide.89464eb1.jpg";